import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Hero from '../components/Hero'
import WhySection from '../components/WhySection'
import VisionMissionSection from '../components/VisionMissionSection'
import PillarsSection from '../components/PillarsSection'
import WhatWeDoSection from '../components/WhatWeDoSection'
import BrandStorySection from '../components/BrandStorySection'
import EcosystemSection from '../components/EcosystemSection'
import CallToAction from '../components/CallToAction'

const Home: React.FC = () => {
  const location = useLocation()

  // Scroll to hash target when navigating with an anchor (e.g. /#pillars)
  useEffect(() => {
    if (!location.hash) return
    const id = location.hash.slice(1)
    // Wait for layout so section refs exist
    const scroll = () => {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    const t = window.setTimeout(scroll, 60)
    return () => window.clearTimeout(t)
  }, [location.hash, location.pathname])

  return (
    <>
      <Hero />
      <WhySection />
      <VisionMissionSection />
      <PillarsSection />
      <WhatWeDoSection />
      <BrandStorySection />
      <EcosystemSection />
      <CallToAction />
    </>
  )
}

export default Home
